/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Hourglass({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.5 1.4a.6.6 0 0 0 0 1.2h.9v.782a4.6 4.6 0 0 0 2.301 3.985L6.8 8l-1.098.633A4.6 4.6 0 0 0 3.4 12.619v.782h-.9a.6.6 0 1 0 0 1.2h11a.6.6 0 1 0 0-1.2h-.9v-.782a4.6 4.6 0 0 0-2.301-3.985L9.2 8l1.098-.633A4.6 4.6 0 0 0 12.6 3.382V2.6h.9a.6.6 0 1 0 0-1.2zm8.9 12v-.782a3.4 3.4 0 0 0-1.701-2.945L8 8.693l-1.7.98a3.4 3.4 0 0 0-1.7 2.945v.782zM4.6 3.382V2.6h6.8v.782a3.4 3.4 0 0 1-1.701 2.945L8 7.307l-1.7-.98a3.4 3.4 0 0 1-1.7-2.945" clipRule="evenodd" /></svg>;
}
;